import $ from 'jquery';

$('body').magnificPopup({
  closeOnBgClick: false,
  closeOnContentClick: false,
  delegate: '.js-cf-resources-modal',
  removalDelay: 500,
  midClick: true,
  type: 'inline',
  callbacks: {
    open: () => {
      $('body').addClass('cf-hero-society-modal-open');
    },
    close: () => {
      $('body').removeClass('cf-hero-society-modal-open');
    },
  },
});



// WEBPACK FOOTER //
// ./assets/js/resources-modal.js